import Constants from "../Constants";
import { ActionInterface } from "../../Interface/ActionInterface";

class SignoutActions {

  public start(): ActionInterface {
    return {
      type: Constants.PAGE_SIGNOUT_START
    };
  }

  public request(): ActionInterface {
    return {
      type: Constants.PAGE_SIGNOUT_REQUEST
    };
  }

  public success(): ActionInterface {
    return {
      type: Constants.PAGE_SIGNOUT_SUCCESS
    };
  }

  public failure(err): ActionInterface {
    return {
      type: Constants.PAGE_SIGNOUT_FAILURE,
      payload: {
        err
      }
    };
  }
}

export default new SignoutActions();
